module.exports = __webpack_public_path__ + "static/media/img1.0c869422.jpeg";